import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

function SetDressingMenu(props) {
  const { filmId, setDressingId: animalId } = props.match.params;
  const { setDressing: animal } = props;
  const invalidIds = ["add", "overview"];
  if (invalidIds.indexOf(animalId) > -1) {
    return null;
  }

  return (
    <div className="blade-menu menu">
      <p className="menu-label">Animals</p>
      <ul className="menu-list">
        <li>
          <NavLink
            to={`/films/${filmId}/set-dressings/${animalId}/edit`}
            activeClassName="is-active">
            Edit Animal
          </NavLink>
        </li>
        {animal?.canAccessScenes &&
          <li>
            <NavLink
              to={`/films/${filmId}/set-dressings/${animalId}/scenes/`}
              activeClassName="is-active">
              Scenes
            </NavLink>
          </li>
        }
      </ul>
    </div>
  );
}

function mapStateToProps(state) {
  const { setDressingsState } = state;
  return {
    setDressing: setDressingsState.setDressing
  };
}

export default connect(mapStateToProps, {
})(SetDressingMenu);
